import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=4b127cdc&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=4b127cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../BuildingCatalog/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b127cdc",
  null
  
)

export default component.exports